import React from 'react';
import { Modal } from 'components';
import { Button } from '@takecasper/acuity-design-system';
import { useTranslation } from 'react-i18next';
import {
  ButtonContainerStyled,
  ModalBodyStyled
} from 'shared/styled-components/users.styles';

const ConfirmNavigationModal = ({ handleOnStayClick, handleOnLeaveClick }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t?.('navigation_confirmation_title')}
      size="small"
      closeModal={handleOnStayClick}
      hideFooter
    >
      <ModalBodyStyled>
        <p>
          {t?.('navigation_confirmation_description_line_1')}
          <br />
          {t?.('navigation_confirmation_description_line_2')}
        </p>
        <ButtonContainerStyled>
          <Button
            data-testid="navigation_confirmation_leave_without_saving"
            data-analytics-id="navigation_confirmation_leave_without_saving"
            label={t?.('navigation_confirmation_leave_without_saving')}
            onClick={handleOnLeaveClick}
            text={t?.('navigation_confirmation_leave_without_saving')}
            variant="secondary"
          />
          <Button
            data-testid="navigation_confirmation_stay"
            data-analytics-id="navigation_confirmation_stay"
            label={t?.('navigation_confirmation_stay')}
            onClick={handleOnStayClick}
            text={t?.('navigation_confirmation_stay')}
            variant="primary"
          />
        </ButtonContainerStyled>
      </ModalBodyStyled>
    </Modal>
  );
};

export default ConfirmNavigationModal;
